/*eslint-disable */
import {
  mapGetters
} from 'vuex';
import moment from 'moment';
import FlipCountdown from 'vue2-flip-countdown'
import userInfo from './user-info-for-conference';
var $ = window.jQuery = require('jquery');
import{ bus } from '@/main';
export default {
  name: 'lymphomap-conference',
  components: {
    'user-info-store' : userInfo,
    FlipCountdown 
  },
  props: [],
  data () {
    return {
      userInfoStoreState:false,
      timeElapsedState:true,
      presentDate: new Date(),
      getPublicVistaMeetingData:null
    }
  },
  computed: {
    ...mapGetters([
      'getPublicVistaMeetingGetters',
    ]),
    getPublicVistaMeetingMethod(){
      this.getPublicVistaMeetingData = this.$store.getters.getPublicVistaMeetingGetters.data
      return
    },
  },
  mounted () {
    bus.$on('userInfoStoreBus', (data) => {
      this.userInfoStoreState = data;
    });
    this.checkDateAndTimeMethod()
  },
  methods: {
    checkDateAndTimeMethod(){
      if(moment().format('MM-DD-YYYY') >= '10-31-2021' && moment().format('HH:mm:ss') >= '11:00:00'){
        this.timeElapsedState = false
      }else{
        this.timeElapsedState = true
      }
    },
    timeElapsedHandler () {
      this.timeElapsedState = false
    },
    discoverNowMethod(){
      this.userInfoStoreState = true
      $('body').addClass('body_right_scroll_remove')
    }
  },
  watch:{
    getPublicVistaMeetingMethod(){
      return this.$store.getters.getPublicVistaMeetingGetters
    },
  },
  beforeCreate: function() {
    $('body').addClass('lymhpomap_recent_conference_wrp')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('lymhpomap_recent_conference_wrp')
    next();
  },
}